import React, { useState, useRef, useEffect } from 'react';

export const OTPInput = ({ length = 6, onOtpChange,clearOtp }) => {
  const [otp, setOtp] = useState(Array(length).fill(''));
  const inputs = useRef([]);


  useEffect(() => {
    if (clearOtp) {
      setOtp(Array(length).fill(''));
      inputs.current[0].focus(); // Focus on the first input
    }
  }, [clearOtp]);
  const handleChange = (e, index) => {
    const { value } = e.target;

    if (value.match(/^\d$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Notify the parent component about the OTP change
      onOtpChange(newOtp.join(''));

      // Move focus to the next input
      if (index < length - 1) {
        inputs.current[index + 1].focus();
      }
    } else if (value === '') {
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);

      if (index > 0) {
        inputs.current[index - 1].focus();
      }

      // Notify the parent component about the OTP change
      onOtpChange(newOtp.join(''));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && otp[index] === '') {
      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {otp.map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={otp[index]}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputs.current[index] = el)}
          style={{
            width: '40px',
            height: '40px',
            margin: '0 5px',
            textAlign: 'center',
            fontSize: '18px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#334155')}
          onBlur={(e) => (e.target.style.borderColor = '#ccc')}
        />
      ))}
    </div>
  );
};
